module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C256"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C513"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduc#page_xiii"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_One_Amer#page_3"
    }
  }, [_c('em', [_vm._v("Chapter One")]), _vm._v(". American Policy Toward the Muslim World")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Two_The#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Two")]), _vm._v(". The United States and the Specter of Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Three_A#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Three")]), _vm._v(". A Peek Into the Seraglio: Americans, Sex, and the Muslim World")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Four_Ame#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Four")]), _vm._v(". American Slavery and the Muslim World")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Five_Ame#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Five")]), _vm._v(". American Captives in the Muslim World")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Six_The#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Six")]), _vm._v(". The Muslim World and American Benevolence")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Seven_Am#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Seven")]), _vm._v(". American Consuls in the Muslim World")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Eight_Re#page_187",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Eight")]), _vm._v(". Remembering the Tripolitan War")])]), _vm._v(" "), _c('p', {
    staticClass: "C513"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Nine_Jam#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Nine")]), _vm._v(". James Riley, the Return of the Captive")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes_#page_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index_#page_257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "C258"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Photo_Se#page_I",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("illustrations follow Chapter Five")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baf98e7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0